/* Careers pages: department filter, FAQ accordion, mobile sticky CTA, and the
   application submit flow. With a resume-inbox endpoint configured (theme setting,
   Google Apps Script relay), applications upload the resume file and email the
   hiring manager directly with the attachment; otherwise the native Shopify
   contact form submits with a resume-link field. */
(function () {
  // department filter (careers page)
  var pills = document.querySelectorAll('[data-dept-pills] [data-dept]');
  if (pills.length) {
    var cards = document.querySelectorAll('[data-job-card]');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var dept = pill.getAttribute('data-dept');
        pills.forEach(function (p) {
          var on = p === pill;
          p.classList.toggle('bg-primary', on);
          p.classList.toggle('text-primary-foreground', on);
          p.classList.toggle('border', !on);
          p.classList.toggle('border-input', !on);
          p.classList.toggle('bg-background', !on);
          p.classList.toggle('hover:bg-accent', !on);
        });
        cards.forEach(function (c) {
          c.style.display = (dept === 'all' || c.getAttribute('data-dept') === dept) ? '' : 'none';
        });
      });
    });
  }

  // FAQ accordion
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-faq-toggle]');
    if (!toggle) return;
    var panel = toggle.parentElement.querySelector('[data-faq-panel]');
    var chevron = toggle.querySelector('svg');
    var open = panel.hidden;
    panel.hidden = !open;
    if (chevron) chevron.style.transform = open ? 'rotate(180deg)' : '';
  });

  // hide the mobile sticky CTA once the roles list is on screen
  var sticky = document.querySelector('[data-careers-sticky]');
  var positions = document.getElementById('open-positions');
  if (sticky && positions && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.style.opacity = entries[0].isIntersecting ? '0' : '1';
      sticky.style.pointerEvents = entries[0].isIntersecting ? 'none' : '';
    }, { threshold: 0.1 }).observe(positions);
  }

  // application forms
  document.querySelectorAll('[data-application-wrap]').forEach(function (wrap) {
    var form = wrap.querySelector('form');
    if (!form) return;
    var endpoint = wrap.getAttribute('data-upload-url');
    var uploadField = wrap.querySelector('[data-resume-upload-field]');
    var linkField = wrap.querySelector('[data-resume-link-field]');
    var fileInput = wrap.querySelector('[data-resume-file]');
    var filenameEl = wrap.querySelector('[data-resume-filename]');
    var errorEl = wrap.querySelector('[data-app-error]');
    var successEl = wrap.querySelector('[data-application-success]');
    var submitBtn = wrap.querySelector('[data-app-submit]');

    // endpoint configured → show the real file field, hide the link fallback
    if (endpoint) {
      if (uploadField) uploadField.hidden = false;
      if (linkField) linkField.style.display = 'none';
      if (fileInput) fileInput.required = true;
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var f = fileInput.files[0];
        if (!f) return;
        if (f.size > 10 * 1024 * 1024) {
          fileInput.value = '';
          filenameEl.textContent = 'That file is over 10 MB — please attach a smaller one.';
          return;
        }
        filenameEl.textContent = f.name + ' (' + Math.round(f.size / 1024) + ' KB)';
      });
    }

    form.addEventListener('submit', function (e) {
      if (!endpoint || !fileInput || !fileInput.files[0]) return; // native contact form path
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending application…';

      var file = fileInput.files[0];
      var reader = new FileReader();
      reader.onload = function () {
        var payload = {
          position: (wrap.querySelector('[data-app-position]') || {}).value || '',
          hiringEmail: wrap.getAttribute('data-hiring-email') || '',
          name: (wrap.querySelector('[data-app-name]') || {}).value || '',
          email: (wrap.querySelector('[data-app-email]') || {}).value || '',
          phone: (wrap.querySelector('[data-app-phone]') || {}).value || '',
          availability: (wrap.querySelector('[data-app-availability]') || {}).value || '',
          note: (wrap.querySelector('[data-app-note]') || {}).value || '',
          filename: file.name,
          mimeType: file.type || 'application/octet-stream',
          data: String(reader.result).split(',')[1],
          page: window.location.href
        };
        // text/plain keeps this a "simple" request (no CORS preflight, which
        // Apps Script web apps cannot answer)
        fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok && d && typeof d === 'object') d.analyticsUnverified = true; return d; }).catch(function () { return { ok: r.ok, analyticsUnverified: true }; }); })
          .then(function (d) {
            if (d && (d.ok || d.result === 'ok')) {
            if (!d.analyticsUnverified && (d.ok === true || d.result === 'ok')) {
              form.dispatchEvent(new CustomEvent('luminate:form-success', { bubbles: true }));
            }
              form.hidden = true;
              if (successEl) { successEl.hidden = false; wrap.appendChild(successEl); }
            } else {
              throw new Error((d && d.error) || 'Upload failed');
            }
          })
          .catch(function () {
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = "We couldn't send your resume automatically — please add a link to it instead, or email it to " + (wrap.getAttribute('data-hiring-email') || 'us') + '. Your form details were NOT lost.';
            }
            if (linkField) linkField.style.display = '';
            if (fileInput) fileInput.required = false;
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit Application';
          });
      };
      reader.readAsDataURL(file);
    });
  });
})();
